module.exports = __webpack_public_path__ + "img/cover_photo.d3c8069e.jpg";